import { PageAudienceFilter, usePageFilterContext } from '@/components/page';
import PendoPlaceholder from '@/components/PendoPlaceholder/PendoPlaceholder';
import ShareMenu from '@/features/ShareMenu';

const CampaignOverviewActions = () => {
  const {
    pageFilters: { audience },
  } = usePageFilterContext();

  return (
    <div className="flex items-center gap-2">
      <PendoPlaceholder />
      <PageAudienceFilter />
      <ShareMenu
        notificationPageKey="campaigns"
        notificationParams={{
          audienceIds: audience?.id,
        }}
      />
    </div>
  );
};

export default CampaignOverviewActions;
